import { Grid } from "@mui/material";
import React from "react";
import APMainGroupInput from "../../../CustomAPMainGroup/apmaingroupinput";
import APListCode from "../../../CustomAPMainGroup/Components/APListCode";
import PropTypes from "prop-types";

export default function ConditionAPSelect(props) {
  const { defaultValue } = props;
  const [apMainGroup, setAPMainGroup] = React.useState("");
  const [apTableData, setAPTableData] = React.useState([]);
  const [sendData, setSendData] = React.useState(false);
  React.useEffect(() => {
    if (sendData === true) {
      props.result({ apMainGroup: apMainGroup, apTableData: apTableData });
    }
    return () => {};
  }, [apMainGroup, apTableData]);
  React.useEffect(async () => {
    await setSendData(false);
    console.log("defaultValue  ap   ", defaultValue);
    if (defaultValue.apMainGroup !== "") {
      await setAPMainGroup(defaultValue.apMainGroup);
      //     setTableData(defaultValue['tableData'])
    }
    try {
      if (defaultValue.apTableData.length > 0) {
        await setAPTableData(defaultValue.apTableData);
      }
    } catch (error) {
      console.error();
    }
    return () => {};
  }, [defaultValue]);
  const resultData = async (provenance, value) => {
    await setSendData(true);
    if (provenance == "APMainGroupInput") {
      await setAPMainGroup(value);
    }
    if (provenance === "APListCode") {
      await setAPTableData(value);
    }
  };
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <APMainGroupInput
            label={"กลุ่มเจ้าหนี้หลัก"}
            resultData={(e) => resultData("APMainGroupInput", e)}
            inputType={"text"}
            keyDown={(e) => keyDown(e)}
            defaultValue={apMainGroup}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <APListCode
            resultData={(e) => resultData("APListCode", e)}
            defaultValue={apTableData}
          />
        </Grid>
      </Grid>
    </>
  );
}

ConditionAPSelect.propTypes = {
  defaultValue: PropTypes.object,
};
